import { useRef } from 'react';

export enum ProducerType {
  PRODUCER = 'PRODUCER',
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
  MODERATOR = 'MODERATOR',
  LISTENER = 'LISTENER',
  CONTENT_SHARING = 'CONTENT_SHARING',
}


export class Producer {
  url: string;
  shmUrl: string;
  name: string;
  isSelf: boolean;
  id: string;
  number: number;
  type: ProducerType;
  isLive: boolean;
  liveRank: number;
  orderRank: number;
  isSpotted: boolean;
  isMenuOpened: boolean;
  audioMute: boolean;
  videoMute: boolean;
  callQuality: number;
  timezone: string;
  participantGuid: string;
  rosterGuid: string;
  streamIndex: number;
  csrc: number;
  speaking: boolean;
  camera: string;
  blurRange: number;

  constructor(url, name, id, number, timezone, streamIndex, isSelf=false ) {
    this.url = url;
    this.shmUrl = url;
    this.name = name;
    this.isSelf = isSelf;
    this.id = id;
    this.number = number;
    this.isLive = false;
    this.type = ProducerType.PRODUCER;
    this.liveRank = 0;
    this.orderRank = Number.MAX_SAFE_INTEGER;
    this.isSpotted = false;
    this.isMenuOpened = false;
    this.audioMute = true;
    this.videoMute = true;
    this.callQuality = 5;
    this.timezone = timezone;
    this.participantGuid = '';
    this.rosterGuid = '';
    this.streamIndex = streamIndex;
    this.csrc = 0;
    this.speaking = false;
    this.camera = '';
    this.blurRange = 0;
  }
}
